export default __webpack_public_path__ + "static/media/search_icon.cddf9c6b.svg";